export default "__VITE_ASSET__ChU9Dz3$__"